module.exports = __webpack_public_path__ + "static/stardust-card-fluid-5991cf299ff4c9f721fea369439268e1.png";